<template>
	<div class="timer-item">
		<v-list-item style="border: 1px solid #e0e0e0; border-radius: 5px" three-line>
			<v-list-item-icon class="mr-3">
				<v-icon v-if="timer.minutes">mdi-timer-sand</v-icon>
				<v-icon v-else>mdi-timer-outline</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					<strong>{{getMinutes}}:{{getSeconds}}</strong>
					<v-chip class="ml-1" small v-if="finished">
						<translate>Done</translate>
					</v-chip>
					<v-chip class="ml-1" small v-if="timer.pause_date">
						<translate>Paused</translate>
					</v-chip>
				</v-list-item-title>
				<v-list-item-subtitle
					v-if="timer.appointment"
					class="font-weight-medium"
				>{{timer.appointment.patient_name}} - {{timer.appointment.location}}</v-list-item-subtitle>
				<v-list-item-subtitle v-if="timer.minutes" class="font-weight-light">
					{{timer.minutes}}
					<translate v-if="timer.minutes > 1" key="minutes">Minutes</translate>
					<translate v-else key="minute">Minute</translate>
					<br />
					{{timer.description}}
				</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-action>
				<v-row no-gutters>
					<template v-if="timer.active">
						<v-btn icon @click="playTimer" :disabled="!owner">
							<v-icon color="primary">mdi-restart</v-icon>
						</v-btn>
						<v-btn icon @click="pauseTimer" :disabled="!owner">
							<v-icon color="primary">mdi-pause</v-icon>
						</v-btn>
					</template>
					<v-btn v-else icon @click="playTimer" :disabled="!owner">
						<v-icon color="primary">mdi-play</v-icon>
					</v-btn>
					<v-btn
						v-if="timer.appointment"
						icon
						:to="{name: 'appointment', params: {pid: timer.appointment.patient_id, aid: timer.appointment.id}}"
						:disabled="!owner"
					>
						<v-icon color="primary">mdi-clipboard-text</v-icon>
					</v-btn>
					<v-btn icon @click="removeTimer" :disabled="!owner">
						<v-icon color="primary">delete</v-icon>
					</v-btn>
					<span
						style="position: absolute; bottom: 5px; right: 10px"
						class="font-weight-thin"
					>{{timer.user_name}}</span>
				</v-row>
			</v-list-item-action>
		</v-list-item>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "TimerItem",
	props: ["timer"],
	data: () => ({
		owner: false,
		minutes: 0,
		seconds: 0,
		timeoutHandler: null,
		finishedNotOwner: false
	}),
	computed: {
		getMinutes() {
			return ("0" + this.minutes).slice(-2);
		},
		getSeconds() {
			return ("0" + this.seconds).slice(-2);
		},
		finished() {
			return !this.timer.active && !this.timer.notification_seen;
		}
	},
	methods: {
		playTimer() {
			axios
				.post("/api/timers/" + this.timer.id + "/start")
				.then(response => {
					console.log(response.data);
					this.$store.dispatch("SET_TIMERS", response.data.timers);
				})
				.catch(error => console.log(error));
		},
		pauseTimer() {
			axios
				.post("/api/timers/" + this.timer.id + "/pause")
				.then(response => {
					console.log(response.data);
					this.$store.dispatch("SET_TIMERS", response.data.timers);
				})
				.catch(error => console.log(error));
		},
		removeTimer() {
			this.$emit("remove-timer", this.timer);
		},
		decrement() {
			if (this.seconds == 0) {
				if (this.minutes == 0) {
					this.finishedNotOwner = true;
					if (this.owner) {
						console.log("entrei");
						axios
							.post("/api/timers/" + this.timer.id + "/complete")
							.then(response => {
								console.log(response.data);
								this.$store.dispatch("SET_TIMERS", response.data.timers);
								this.$emit("show-notification", this.timer);
							})
							.catch(error => console.log(error));
					} else {
						this.$emit("show-notification", this.timer);
					}
				} else {
					this.minutes--;
					this.seconds = 59;
				}
			} else {
				this.seconds--;
			}
			if (!this.finished && !this.finishedNotOwner)
				this.timeoutHandler = setTimeout(() => this.decrement(), 1000);
		},
		increment() {
			if (this.seconds == 59) {
				this.minutes++;
				this.seconds = 0;
			} else {
				this.seconds++;
			}
			this.timeoutHandler = setTimeout(() => this.increment(), 1000);
		},
		init() {
			if (!this.timer.minutes) {
				this.minutes = 0;
				this.seconds = 0;
			} else {
				this.minutes = this.timer.minutes;
				this.seconds = 0;
			}
			if (this.timer.active) {
				const start_date = this.timer.start_date;
				const now = new Date();
				if (!this.timer.minutes) {
					let timePassed = this.calculateTimePassed(start_date, now.getTime());
					this.minutes = timePassed.minutes;
					this.seconds = timePassed.seconds;
					this.timeoutHandler = setTimeout(() => this.increment(), 1000);
				} else {
					let timeLeft = this.calculateTimeLeft(start_date, now.getTime());
					if(timeLeft) {
						this.minutes = timeLeft.minutes;
						this.seconds = timeLeft.seconds;
						this.timeoutHandler = setTimeout(() => this.decrement(), 1000);
					}
				}
			}
			else if(this.timer.pause_date != null) {
				const start_date = this.timer.start_date;
				const pause_date = this.timer.pause_date;
				if (!this.timer.minutes) {
					let timePassed = this.calculateTimePassed(start_date, pause_date);
					this.minutes = timePassed.minutes;
					this.seconds = timePassed.seconds;
				}
				else {
					let timeLeft = this.calculateTimeLeft(start_date, pause_date);
					if(timeLeft) {
						this.minutes = timeLeft.minutes;
						this.seconds = timeLeft.seconds;
					}
				}
			}
		},
		calculateTimePassed(oldestDate, latestDate) {
			var differencePassed = latestDate - oldestDate;
			console.log(differencePassed);

			var wholeSecondsPassed = Math.abs(differencePassed) / 1000;
			var minutesPassed = Math.floor(wholeSecondsPassed / 60) % 60;
			wholeSecondsPassed -= minutesPassed * 60;
			var secondsPassed = Math.floor(wholeSecondsPassed % 60);

			return {
				minutes: minutesPassed,
				seconds: secondsPassed
			};
		},
		calculateTimeLeft(oldestDate, latestDate) {
			const end_date = oldestDate + this.timer.minutes * 60000
			const difference = end_date - latestDate;
			console.log("Oldest Date: " + oldestDate);
			console.log("Latest Date: " + latestDate);
			console.log("End Date: " + end_date);
			console.log("Difference: " + difference);
			if (difference < 0) {
				this.minutes = 0;
				this.seconds = 0;
				this.finishedNotOwner = true;
				return false
			} else {
				var wholeSeconds = Math.abs(difference) / 1000;
				console.log(wholeSeconds);
				var minutesLeft = Math.floor(wholeSeconds / 60) % 60;
				console.log("Minutes: " + minutesLeft);
				wholeSeconds -= minutesLeft * 60;
				console.log("Seconds: " + wholeSeconds);
				var secondsLeft = Math.floor(wholeSeconds % 60);
				console.log("Secondsss: " + secondsLeft);

				return {
					minutes: minutesLeft,
					seconds: secondsLeft
				}
			}
		}
	},
	mounted() {
		if (this.$store.getters.userId == this.timer.user_id) this.owner = true;
		this.init();
	},
	watch: {
		timer() {
			clearTimeout(this.timeoutHandler);
			this.init();
		}
	}
};
</script>